/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SuggestionAnswer = {
    properties: {
        id: {
    type: 'number',
},
        questionId: {
    type: 'number',
    isRequired: true,
},
        question: {
    type: 'string',
    isRequired: true,
},
        answer: {
    type: 'string',
    isRequired: true,
},
    },
};